const scrollButton = {
  position: "absolute",
  top: "20%",
  zIndex: 1000,
  backgroundColor: "rgba(255, 255, 255, 0.95)",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 1)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
  },
  width: 40,
  height: 40,
};

const leftScrollButton = {
  ...scrollButton,
  left: -50,
};

const rightScrollButton = {
  ...scrollButton,
  right: -50,
};

const scrollIcon = {
  fontSize: 16,
  color: "#367598",
};

const wrapperBox = {
  position: "relative",
  width: "100%",
};

export { leftScrollButton, rightScrollButton, scrollIcon, wrapperBox };

